import { render, staticRenderFns } from "./catalog-choice-label.vue?vue&type=template&id=17a640de&scoped=true&"
import script from "./catalog-choice-label.vue?vue&type=script&lang=js&"
export * from "./catalog-choice-label.vue?vue&type=script&lang=js&"
import style0 from "./catalog-choice-label.vue?vue&type=style&index=0&id=17a640de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a640de",
  null
  
)

export default component.exports